import { Box } from '@mui/material'
import { useCustomTheme } from 'contexts/theme'
import useRedirects from 'hooks/use-redirects'
import { Fragment, PropsWithChildren } from 'react'
import { useStyles } from './styles'

const PermissionLayout = ({ children }: PropsWithChildren) => {
  const classes = useStyles()

  const { theme } = useCustomTheme()

  useRedirects()

  if (theme.name !== 'default') {
    return (
      <Fragment>
        {children}

        <Box className={classes.footerLogo}>
          <span>Powered By</span>
          <img
            src='/default/logo.svg'
            alt='powered logo'
          />
        </Box>
      </Fragment>
    )
  }

  return <Fragment>{children}</Fragment>
}

export default PermissionLayout
